import { action, observable } from 'mobx';
import { FieldStateV3 } from '../../../../commonv3/states/form/FormStateV3';
import { CouponApis } from '../../../apis/coupons';
import { MembershipPlanId } from '../../../../commonv3/types/membershipPlans';
import { ApiError, translateErrorMessage } from '../../../../commonv3/api/protocol';

export class CouponState {
    @observable couponCodeField = new FieldStateV3<string>();
    @observable appliedCouponCode = null;
    @observable appliedCoupon = null;

    async init() {
        this.clearCouponForm();
        await this.loadDefaultCoupon();
    }

    @action.bound
    async submit(email: string, membershipPlanId?: MembershipPlanId) {
        this.appliedCouponCode = null;
        this.couponCodeField.clearErrors();
        try {
            const coupon = await CouponApis.show(this.couponCodeField.getDirtyValue(), email, membershipPlanId);
            if (coupon) {
                this.appliedCouponCode = coupon.code;
                this.appliedCoupon = coupon;
            } else {
                this.couponCodeField.setErrors(['クーポンが見つかりませんでした。コードを確認してください。']);
            }
        } catch (e) {
            if (e instanceof ApiError && e.isNotFoundError()) {
                this.couponCodeField.setErrors(['クーポンが見つかりませんでした。コードを確認してください。']);
            } else if (e instanceof ApiError && e.isOperationalError()) {
                this.couponCodeField.setErrors([translateErrorMessage(e)]);
            } else {
                this.couponCodeField.setErrors([
                    'このクーポンはお使いいただけません。サポートにお問い合わせください。',
                ]);
            }
        }
    }

    async loadDefaultCoupon() {
        const coupon = await CouponApis.default_coupon();
        if (coupon) {
            this.appliedCouponCode = coupon.code;
            this.appliedCoupon = coupon;
        }
    }

    @action.bound
    clearCoupons() {
        this.appliedCoupon = null;
        this.appliedCouponCode = null;
        this.clearCouponForm();
    }

    clearCouponForm() {
        this.couponCodeField.setDirtyValue('');
        this.couponCodeField.clearErrors();
    }
}
